// src/pages/Modal/ModalOverlay.tsx
import { useNavigate } from 'react-router-dom'

type Props = {
  bgColor?: string
  onClickFunc?: () => void
}

function ModalOverlay({ bgColor = '#0008', onClickFunc }: Props) {
  const navigate = useNavigate()

  const back = (e: any) => {
    e.stopPropagation()
    navigate(-1)
  }

  return (
    <div
      style={{
        position: 'absolute',
        width: '100%',
        height: '100vh',
        top: 0,
        left: 0,
        backgroundColor: bgColor,
      }}
      onClick={onClickFunc ?? back}
    />
  )
}

export default ModalOverlay
